export interface OtpOptions {
    options: OtpOption[];
}

export interface SendOtpResponse {
    success: boolean;
    maskedPhoneNumber: string;
    option: OtpOption;
}

export enum OtpOption {
    SMS = 'SMS',
    CALL = 'CALL',
    TOTP = 'TOTP',
}

export enum OtpRequestType {
    CREATE_BANK = 'CREATE_BANK',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD'
}

